import { Component, OnInit, Input, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuthService, FirestoreService } from 'src/app/services/service.index';
import { AngularFireStorage } from '@angular/fire/storage';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-customerform',
  templateUrl: './customerform.component.html',
  styleUrls: ['./customerform.component.css']
})
export class CustomerformComponent implements OnInit {

  @Input() user: any;

    // Accessing HTML Element
    @ViewChild('mapContainer', { static: false }) gmap: ElementRef;

  forma: FormGroup;

  urlImg:any = "../../../assets/img/images.jpeg";
  imageTemp: string;

  cliente:any = {};

  selectedFile: File = null;
  uploadPercent: Observable<number>;
  downloadURL: Observable<string>;

  activo = false;

  mensajeArchivo = '';
  nombreArchivo = '';

  porcentaje :any ='';
  snapshot:any;
  finalizado = false;
  total = 0;
  img = false;

  nueva:any;

  banDir = false;

  address:any;
  addressDir:any = null;

  lat:any;
  lng:any;




  productLat;
  productLong;
  userLat;
  userLong;
  map: google.maps.Map;
  listingPlace;
  distanceProductToUser;
  marker:any;

  regionName:any;
  region:any;
  companyId:any;

  selectedStatus = "1";
  selectedType = "0";

  constructor(private http: HttpClient, private auth: AuthService, private afs: FirestoreService, private storage: AngularFireStorage, @Inject(DOCUMENT) private document, private router: Router) { }

  ngOnInit(): void {

    this.user = this.afs.usersShow;

    this.companyId = this.user.companyId;

    console.log(this.companyId);


    this.forma = new FormGroup({
      companyname: new FormControl( null, Validators.required),
      firstnamecontact: new FormControl( null, Validators.required),
      lastnamecontact: new FormControl(),
      phone: new FormControl(),
      identification: new FormControl(),
    /* password: new FormControl(null, Validators.required),
      password2: new FormControl(null, Validators.required),*/
      typeuser: new FormControl(3),
      address: new FormControl(" "),
      description: new FormControl(" "),
      region: new FormControl("Region"),
      houropen: new FormControl(),
      hourclose: new FormControl(),
      latitude:  new FormControl(0),
      longitude: new FormControl(0),
      email: new FormControl(null, [Validators.required, Validators.email]),
      status: new FormControl(true),
      role: new FormControl("US")
    }, {
       // validators: this.samePassword('password','password2')
    });



  }


  ngAfterViewInit() {
    this.mapInitializer();
    // get our location
    //this.getLocation();
      //calculate our location distance to product
     // this.calculateDistanceUserToProduct();
   }


  samePassword(field1: string, field2: string){
    return (group: FormGroup) => {

      let pass1 = group.controls[field1].value;
      let pass2 = group.controls[field2].value;

        if(pass1===pass2){
            return null;
        }

        return {
          samePassword: true
        }
    }
}

createCustomer(){


  if(this.forma.invalid){
    return;
  }

  let data:any = {};
  let regions = {};
  data = this.forma.value;
  regions[this.region] = true;
  data['regions']=regions;


  this.afs.createCustomer(this.companyId, data).then((resp) => {


         data.id = resp.id

        this.afs.updateCustomerByCompany(this.companyId, resp.id, data).then(res => {


           Swal.fire(
             'Good job!',
             'Customer ha been registered Successful!',
             'success'
           );

          this.router.navigate(['/customers']);

        }).catch(err => {

          console.log(err);

        })



  }).catch((err) => {


     Swal.fire('Oops...', 'Customer has not been registered!!!', 'error');

  });



}

getAddress(place: object) {

  this.addressDir = place['formatted_address'];
  this.address = place['geometry'];
  //this.registro.direccion = this.addressDir;

  this.lat = this.address.location.lat();
  this.lng = this.address.location.lng();


  this.afs.getAllRegionPro(this.user.companyId).then(res =>{

      res.forEach((doc)=>{
          //console.log(doc.id);
          //console.log(doc.data());
          let location = [ this.lat, this.lng];

          let idRegion = doc.id;
          let regionData = doc.data();
          let regionPolygon = doc.data().polygon;

          let  pointArr = [];

          Object.keys(regionPolygon).forEach((id) => {
              var point = [
                  regionPolygon[id].lat,
                  regionPolygon[id].lng,
              ];
              pointArr.push(point);
          });

          //console.log(pointArr);

          if(this.afs.inside(location, pointArr)){
              //console.log(regionData.name);
              this.regionName = regionData.name;
              this.region = idRegion;
              this.forma.controls['region'].setValue(this.regionName);
          }

      });

  }).catch(err=>{
      console.log(err);
  });


  this.forma.controls['latitude'].setValue(this.lat);
  this.forma.controls['longitude'].setValue(this.lng);
  this.forma.controls['address'].setValue(this.addressDir);


  const coordinates = new google.maps.LatLng(this.lat, this.lng);

  this.marker = new google.maps.Marker({
    position: coordinates,
    map: this.map
  })

  const mapOptions: google.maps.MapOptions = {
    // here to place centering our location based on coordinates
    center: coordinates,
    zoom: 18,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false
    };

    this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
    this.marker.setMap(this.map);
   }


   mapInitializer() {

    navigator.geolocation.getCurrentPosition((position) => {
    // place your product lat or longtitude here
    this.productLat = position.coords.latitude;// change it to your preferences
    this.productLong = position.coords.longitude; // <-- static
    const coordinates = new google.maps.LatLng(this.productLat, this.productLong); // init our coordinate for marker :)
    this.marker = new google.maps.Marker({
      position: coordinates,
      map: this.map
    })
    // check here to get to know about map options docs
    const mapOptions: google.maps.MapOptions = {
    // here to place centering our location based on coordinates
    center: coordinates,
    zoom: 18,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false
    };
    //set our lovely google maps here and marker here
    this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
    this.marker.setMap(this.map);
    // get address name based on latitude and longtitude
    // here we do Reverse Geocoding technique that convert Latitude and // longtitude to be lovely human readable information like address
    /*this.getProductAddressMap().subscribe((data: any) => {

      this.listingPlace =  data.results[1].address_components[0].short_name;

    })*/
  })
    }


      getLocation(){
        navigator.geolocation.getCurrentPosition((position) => {
          this.userLat = position.coords.latitude;
          this.userLong = position.coords.longitude;
           this.calculateDistanceUserToProduct(); }, error => {
          alert("Please Allow Google Maps in your Browser");
          })
      }

      calculateDistanceUserToProduct(){

        var earthRadius = 6371 // Radius of the earth in km

        var dLat = this.deg2rad(this.productLat - this.userLat);

        var dLon = this.deg2rad(this.productLong - this.userLong);

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +

        Math.cos(this.deg2rad(this.userLat)) * Math.cos(this.deg2rad(this.productLat)) *

        Math.sin(dLon / 2) * Math.sin(dLon / 2);

        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        var dist = earthRadius * c; // Distance in km
        var finalDist = dist.toFixed(2);
        if(finalDist == 'NaN'){
          this.distanceProductToUser = null;
        }else{
          this.distanceProductToUser = finalDist;
        }
        console.log("final dist",this.distanceProductToUser);
      }

      deg2rad(deg) {
         return deg * (Math.PI / 180)
      }




}
